import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { Container } from "react-bootstrap"
import { Link, useParams } from "react-router-dom"
import { toast } from "react-toastify"
import Loader from "components/Loader"
import { archiveAdminProduct, getAdminProduct } from "requesters/productRequester"
import { roleCheck } from "utils/index"
import { ADMIN } from "utils/constants"
import { getCurrentRole, getCurrentUser, getBaseUrl } from "apps/App/reducers"
import _ from "lodash"
import ProductForm from "./ProductForm"
import { apiErrorMessage } from "./productSettings"

const toastOptions = {
  toastId: "products-admin",
  containerId: "main"
}

export default function EditProduct() {
  const { id } = useParams()
  const baseUrl = useSelector(getBaseUrl)
  const currentUser = useSelector(getCurrentUser)
  const currentRole = useSelector(getCurrentRole)
  const systemRole = currentUser.attributes.role
  const [product, setProduct] = useState(null)
  const [requesting, setRequesting] = useState(true)
  const [loadError, setLoadError] = useState(false)
  const [archiveRequested, setArchiveRequested] = useState(false)

  if (!roleCheck(systemRole, currentRole, ADMIN)) window.location = "/"

  useEffect(() => {
    async function fetchData() {
      setRequesting(true)
      const { response, error } = await getAdminProduct(baseUrl, id)
      if (response) {
        setProduct(_.get(response, `product.${id}`) || _.values(response.product || {})[0])
        setLoadError(false)
      } else {
        console.error(error)
        setLoadError(true)
      }
      setRequesting(false)
    }

    if (baseUrl) fetchData()
  }, [baseUrl, id])

  async function triggerArchive() {
    setArchiveRequested(true)
    const nextArchived = !product.attributes.archived
    const { response, error } = await archiveAdminProduct(baseUrl, id, nextArchived)
    if (response) {
      const updated = _.get(response, `product.${id}`) || _.values(response.product || {})[0]
      if (updated) setProduct(updated)
      toast.success(nextArchived ? "Product archived" : "Product restored", toastOptions)
    } else {
      console.error(error)
      toast.error(apiErrorMessage(error, "Failed to update product"), toastOptions)
    }
    setArchiveRequested(false)
  }

  if (requesting) {
    return (
      <Container fluid className="pb-5">
        <Loader />
      </Container>
    )
  }

  if (loadError || !product) {
    return (
      <Container fluid className="pb-5">
        <p className="text-muted">Unable to load this product.</p>
        <Link className="btn btn-outlined-blue" to="/settings/products">
          Back to list
        </Link>
      </Container>
    )
  }

  return (
    <Container fluid className="pb-5">
      <ProductForm
        key={product.id}
        product={product}
        onArchive={triggerArchive}
        archiving={archiveRequested} />
    </Container>
  )
}
